import { Node_Type } from './../../../ricos-schema/next-schema';

import type { IEditorQuery, ITreeNodeQuery, QueryItem } from '../../types';

const NAME = 'isOnlySlashInParagraph';
const isOnlySlashInParagraph: QueryItem =
  ({ editorQuery }: { editorQuery: IEditorQuery }) =>
  () => {
    const { doc } = editorQuery.selection();
    let hasOnlySlashInParagraph = false;

    doc.descendants((node: ITreeNodeQuery) => {
      if (
        node.isTextBlock() &&
        node.toNode()?.nodes &&
        node.toNode()?.nodes.length === 1 &&
        node.toNode()?.nodes[0].type === Node_Type.TEXT &&
        node.toNode()?.nodes[0].textData?.text === '/'
      ) {
        hasOnlySlashInParagraph = true;
        return false;
      }
      return true;
    });

    return hasOnlySlashInParagraph;
  };

export default { NAME, query: isOnlySlashInParagraph };
